import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import OtpInput from "react-otp-input";
import { httpUnAuth } from "../Utils/http";
import { toast } from "react-toastify";
import { actionTypes } from "../Utils/Constants";

export default function Header(props) {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const pattern = /^[0-9\b]+$/;

  const [scrolled, setScrolled] = useState(false);
  const [otp, setOtp] = useState("");
  const [showOTP, setShowOTP] = useState(false);
  const [username, setUsername] = useState("");
  const [showResend, setShowResend] = useState(false);
  const [seconds, setSeconds] = useState(30);
  const [int, setInt] = useState();

  const handleScroll = () => {
    const offset = window.scrollY;
    if (offset > 20) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
  });

  useEffect(() => {
    if (!showResend && seconds > 0 && showOTP) {
      setInt(
        setInterval(() => {
          setSeconds((prev) => prev - 1);
        }, 1000)
      );
    }
    return () => {
      clearInterval(int);
    };
  }, [showOTP, showResend]);

  const handleLogin = () => {
    if (!auth.token) {
      dispatch({ type: actionTypes.SHOW_LOGIN });
    }
  };

  const handleMobileChange = (e) => {
    if (
      e.target.value.length <= 10 &&
      (e.target.value === "" || pattern.test(e.target.value))
    ) {
      setUsername(e.target.value);
    }
  };

  const updateShowResend = () => {
    setTimeout(() => {
      setShowResend(true);
    }, 30000);
  };

  const handleMobileSubmit = () => {
    if (username) {
      httpUnAuth
        .post("v1/signin", { username })
        .then((res) => {
          toast.success("OTP sent to your mobile successfully.");
          setShowOTP(true);
          updateShowResend();
        })
        .catch((err) => {
          toast.error(err.message);
        });
    }
  };

  const handleOtpSubmit = () => {
    if (otp) {
      dispatch({
        type: actionTypes.INIT_LOGIN,
        params: { username, password: otp },
      });
    }
  };

  const handleLogout = () => {
    dispatch({ type: actionTypes.LOGOUT_INIT });
  };

  const handleResendClick = () => {
    handleMobileSubmit();
    setShowResend(false);
    setSeconds(30);
  };

  return (
    <>
      <div className="header">
        <Row>
          <Col
            className={
              scrolled === true ? "we_header_1" : "we_header_1 logo_big"
            }
          >
            <img src={process.env.PUBLIC_URL + "/image/logo.svg"} alt="" />
          </Col>
          <Col className="we_header_2">
            <a href="tel:18001024247">
              <img src={process.env.PUBLIC_URL + "/image/icon-2.svg"} alt="" />
            </a>
            {auth.token ? (
              <Link to="#" onClick={handleLogout}>
                <img
                  src={process.env.PUBLIC_URL + "/image/signoff.svg"}
                  alt=""
                />
              </Link>
            ) : (
              <Link to="#" onClick={handleLogin}>
                <img
                  src={process.env.PUBLIC_URL + "/image/icon-1.svg"}
                  alt=""
                />
              </Link>
            )}
          </Col>
        </Row>
      </div>
      {!auth.token && (
        <div className={auth.showLogin ? "otp_modal show" : "otp_modal"}>
          <div className="opt_modal_cnt">
            <div className="line"></div>
            <Link
              to="#"
              className="close-otp"
              onClick={() => dispatch({ type: actionTypes.HIDE_LOGIN })}
            >
              <img src={process.env.PUBLIC_URL + "/image/close.svg"} alt="" />
            </Link>
            {!showOTP ? (
              <>
                <h2>Enter Mobile Number</h2>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleMobileSubmit();
                  }}
                >
                  <Row className="otp_input m-contact">
                    <Col xs="12">
                      <input
                        type="text"
                        placeholder="Mobile Number"
                        value={username}
                        onChange={handleMobileChange}
                      />
                    </Col>
                  </Row>
                  <button type="submit">Submit</button>
                </form>
              </>
            ) : (
              <>
                <h2>Enter OTP</h2>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleOtpSubmit();
                  }}
                >
                  <OtpInput
                    value={otp}
                    onChange={(newOtp) => setOtp(newOtp)}
                    numInputs={4}
                    inputStyle="otp-input"
                    placeholder="----"
                    isInputNum
                    renderInput={(props) => <input {...props} />}
                  />
                  <button type={"submit"}>Submit</button>
                </form>
                <p className={showResend ? "resend" : ""}>
                  {showResend ? (
                    <p onClick={handleResendClick}>Resend OTP?</p>
                  ) : (
                    <>Resend OTP in {seconds} seconds</>
                  )}
                </p>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}
